import { create } from "zustand";
import { devtools } from "zustand/middleware";

type AuthState = {
  isLoggedIn: boolean;

  setLogin: (token: string) => void;
  logout: () => void;
};

const isDev = process.env.NODE_ENV === "development";

export const useAuthStore = create<AuthState>()(
  devtools(
    (set) => ({
      isLoggedIn: false,

      setLogin: (token) =>
        set(
          {
            isLoggedIn: true,
          },
          false,
          "auth/setLogin" // ✅ Redux DevTools 액션 이름
        ),

      logout: () =>
        set(
          {
            isLoggedIn: false,
          },
          false,
          "auth/logout" // ✅ Redux DevTools 액션 이름
        ),
    }),
    {
      name: "auth-store", // ✅ DevTools에 표시될 store 이름
      enabled: isDev, // ✅ 개발 환경에서만
    }
  )
);
